module.exports = __webpack_public_path__ + "static/js/runBigTaskWorker.0e6c59eb.chunk.worker.js"